import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { ProductCardStub } from './components/ProductCardStub';

const ProductCardLazy = loadable(() => import(/* webpackChunkName: "ProductCard" */ './ProductCardSuspense'));

export const ProductCardAsync = () => (
    <DelayedSuspense fallback={<ProductCardStub />}>
        <ProductCardLazy />
    </DelayedSuspense>
);
